export default {"src":"/_next/static/media/Missouri.623858a2.svg","height":554,"width":800,"blurWidth":0,"blurHeight":0};